/**
 * YouTube video facade — replaces the poster+play button with an autoplaying
 * YouTube iframe on first interaction. Keeps the initial page load light
 * (no YouTube player JS until the user actually clicks).
 *
 * Activated on any `<button class="video-full__facade" data-youtube-id="...">`
 * emitted by the acf/video-full block when given a YouTube URL.
 */
(function () {
	'use strict';

	function init() {
		var nodes = document.querySelectorAll('.video-full__facade[data-youtube-id]');
		if (!nodes.length) return;

		Array.prototype.forEach.call(nodes, function (btn) {
			btn.addEventListener('click', function () {
				var id = btn.getAttribute('data-youtube-id');
				if (!id) return;

				var iframe = document.createElement('iframe');
				iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
				iframe.title = 'YouTube video player';
				iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
				iframe.setAttribute('allowfullscreen', '');

				btn.parentNode.replaceChild(iframe, btn);
				iframe.focus();
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
